var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconQuestion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 300",
    style: {
      enableBackground: "new 0 0 300 300"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.icon_question{fill:#6086AD;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "icon_question",
    d: "M275,150c0,69.036-55.964,125-125,125S25,219.036,25,150S80.964,25,150,25S275,80.964,275,150z  M134.543,172.915h23.888l2.575-14.287c6.401-1.246,12.396-3.003,17.978-5.269c5.585-2.26,10.434-5.269,14.546-9.016 c4.11-3.746,7.367-8.275,9.77-13.583c2.404-5.306,3.609-11.71,3.609-19.204v-0.469c0-7.806-1.359-14.713-4.073-20.725 c-2.715-6.008-6.555-11.085-11.515-15.223c-4.965-4.135-10.909-7.261-17.827-9.368c-6.921-2.109-14.594-3.163-23.026-3.163 c-12.803,0-23.849,2.328-33.137,6.98c-9.292,4.65-17.37,10.694-24.24,18.134l21.546,23.6c5.464-5.464,11.044-9.523,16.746-12.179 c5.697-2.653,11.826-3.982,18.383-3.982c6.868,0,12.178,1.452,15.925,4.359c3.748,2.905,5.622,7.028,5.622,12.371v0.469 c0,6.287-3.124,11.275-9.368,14.962c-6.246,3.694-16.785,5.853-31.616,6.481l-1.171,1.171L134.543,172.915z M126.582,228.652h37.704 v-37.471h-37.704V228.652z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuestion);
export default __webpack_public_path__ + "static/media/icon_question.f8c495b0.svg";
export { ForwardRef as ReactComponent };